<template>
  <div>
    <b-form-group
      :label="$t('toolbar.adminUsers.firstNames') + ':'"
      label-for="first_name-input"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <b-form-input
        id="first_name-input"
        name="first_name-input"
        type="text"
        v-model="User.first_name"
        :disabled="true"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('toolbar.adminUsers.lastNames') + ':'"
      label-for="last_name-input"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <b-form-input
        id="last_name-input"
        name="last_name-input"
        type="text"
        :disabled="true"
        v-model="User.last_name"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('toolbar.adminUsers.email') + ':'"
      label-for="email-input"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <div class="d-flex">
        <div class="d-blok w-100">
          <b-form-input
            id="email-input"
            name="email-input"
            type="text"
            v-model="User.email"
            :disabled="true"
          ></b-form-input>
        </div>
      </div>
    </b-form-group>
    <b-form-group
      :label="$t('toolbar.adminUsers.role') + ':'"
      label-for="role-input"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <b-form-select
        id="select-role"
        name="select-role"
        :options="Roles"
        value-field="id"
        text-field="position_name"
        :disabled="true"
        v-model="access.role"
      >
      </b-form-select>
    </b-form-group>
    <template v-if="!isNaN(access.id)">
      <!-- egressProfilesCanUpdate: {{ egressProfilesCanUpdate }} <br />
      facultiesCanUpdate: {{ facultiesCanUpdate }} <br />
      hasFacultiesPermission: {{ hasFacultiesPermission }} <br />
      hasEgressProfilesPermission: {{ hasEgressProfilesPermission }} <br /> -->
      <div
        class="accordion"
        role="tablist"
        v-for="table in tablesListFiltered"
        :key="table.id"
      >
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle="String('key_id:' + table.id)"
              variant="primary"
              class="d-flex justify-content-center align-items-center"
            >
              {{
                $getVisibleNames(table.name, true, table.adapted_viewable_name)
              }}
              <b-icon
                icon="chevron-down"
                class="ml-2"
                :style="{
                  transform:
                    active_collapse_id == String('key_id:' + table.id)
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }"
              ></b-icon>
            </b-button>
          </b-card-header>
          <b-collapse
            :id="String('key_id:' + table.id)"
            accordion="my-accordion"
            role="tabpanel"
            @show="active_collapse_id = String('key_id:' + table.id)"
            @hidden="
              active_collapse_id == String('key_id:' + table.id)
                ? (active_collapse_id = null)
                : null
            "
          >
            <b-card-body>
              <template v-if="table.name == 'special.close_egress_profile'">
                <SpecialPermissionTable
                  :access="access"
                  :table_access="table_access"
                  :fields="fields_close_egress_profiles"
                  :url="'/mesh/alt-egress-profile/'"
                  :busy_table="busy_table"
                  :Roles="Roles"
                  :permission_names="['special.close_egress_profile']"
                >
                </SpecialPermissionTable>
                <!-- <SpecialAccessCard
                  :Table="table"
                  :Items="egressProfiles"
                  :Access="access"
                  :allows_crud="allows_crud"
                >
                </SpecialAccessCard> -->
              </template>
              <template v-else-if="table.name == 'mesh.faculty'">
                <div
                  v-if="access && isRoleFacultyDirectors"
                  class="alert alert-info mb-3"
                >
                  <small>
                    {{
                      $t("toolbar.adminUsers.accessFacultyDirectorWarning", {
                        entity1: $getVisibleNames(
                          "mesh.career",
                          true,
                          "Programa"
                        ),
                        entity2: $getVisibleNames(
                          "mesh.faculty",
                          true,
                          "Facultad"
                        ),
                      })
                    }}
                  </small>
                </div>
                <PermissionTable
                  :access="access"
                  :table_access="table_access"
                  :fields="fields_faculties"
                  :busy_table="busy_table"
                  :permission_names="[
                    'can_create',
                    'can_read',
                    'can_update',
                    'can_delete',
                  ]"
                  :table_name="'mesh.faculty'"
                  :url="'/mesh/alt-faculty/'"
                  @changed_permissions="changedPermissions"
                ></PermissionTable>
                <!-- <AccessCard
                  :Table="table"
                  :Items="faculties"
                  :Access="access"
                  :allows_crud="allows_crud"
                >
                </AccessCard> -->
              </template>
              <template v-else-if="table.name == 'mesh.career'">
                <div
                  v-if="access && isRoleInstructionalAdministrators"
                  class="alert alert-info mb-3"
                >
                  <small>
                    {{
                      $t("toolbar.adminUsers.accessInstructionalAdminWarning", {
                        entity: $getVisibleNames(
                          "manual.matter_program",
                          false,
                          "Programa de Asignatura"
                        ),
                      })
                    }}
                  </small>
                </div>
                <div
                  v-if="access && isRoleCareerDirectors"
                  class="alert alert-info mb-3"
                >
                  <small>
                    {{
                      $t(
                        "toolbar.adminUsers.accessCareerDirectorOrEgressWarning",
                        {
                          entity: $getVisibleNames(
                            "mesh.career",
                            true,
                            "Programa"
                          ),
                        }
                      )
                    }}
                  </small>
                </div>

                <PermissionTable
                  :access="access"
                  :table_access="table_access"
                  :fields="fields_career"
                  :busy_table="busy_table"
                  :permission_names="
                    access && isRoleInstructionalAdministrators
                      ? ['can_read', 'can_update', 'can_delete']
                      : ['can_create', 'can_read', 'can_update', 'can_delete']
                  "
                  :table_name="'mesh.career'"
                  :url="'/mesh/alt-career/'"
                ></PermissionTable>
                <!-- <AccessCard
                  :Table="table"
                  :Items="careers"
                  :Access="access"
                  :allows_crud="allows_crud"
                >
                </AccessCard> -->
              </template>
              <template v-else-if="table.name == 'mesh.egressprofile'">
                <div
                  v-if="access && isRoleInstructionalAdministrators"
                  class="alert alert-info mb-3"
                >
                  <small>
                    {{
                      $t("toolbar.adminUsers.accessInstructionalAdminWarning", {
                        entity: $getVisibleNames(
                          "manual.matter_program",
                          false,
                          "Programa de Asignatura"
                        ),
                      })
                    }}
                  </small>
                </div>
                <div
                  v-if="access && isRoleCareerDirectors"
                  class="alert alert-info mb-3"
                >
                  <small>
                    {{
                      $t(
                        "toolbar.adminUsers.accessCareerDirectorOrEgressWarning",
                        {
                          entity: $getVisibleNames(
                            "mesh.egressprofile",
                            true,
                            "Perfiles de egreso"
                          ),
                        }
                      )
                    }}
                  </small>
                </div>

                <PermissionTable
                  :access="access"
                  :table_access="table_access"
                  :fields="fields_egress_profiles"
                  :busy_table="busy_table"
                  :permission_names="
                    access && isRoleInstructionalAdministrators
                      ? ['can_read', 'can_update', 'can_delete']
                      : ['can_create', 'can_read', 'can_update', 'can_delete']
                  "
                  :table_name="'mesh.egressprofile'"
                  :url="'/mesh/alt-egress-profile/'"
                  @changed_permissions="changedPermissions"
                ></PermissionTable>
              </template>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!-- Grupo 1: Egress Profile Matter -->
      <!-- <b-card v-if="access && access.role__position__name == 1" no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle="'group_egress_profile'" variant="info">
            {{
              $getVisibleNames("mesh.egressprofilematter", false, "Asignatura")
            }}
          </b-button>
        </b-card-header>
        <b-collapse
          id="group_egress_profile"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <LockAccessCard
              :Table="tablesListDualFiltered"
              :Items="filterEPMatters"
              :Access="access"
              :allows_crud="allows_crud"
              :close_name="'special.close_egress_profile_matter'"
              :egress_profile_matter_card="true"
            />
          </b-card-body>
        </b-collapse>
      </b-card> -->

      <!-- Grupo 2: Base Matter -->
      <b-card
        v-if="
          access &&
          (isRoleInstitutionalAcademicDirectors ||
            (isRoleFacultyDirectors && hasFacultiesPermission) ||
            (isRoleCareerDirectorsOrInstructionalAdministrators &&
              hasEgressProfilesPermission))
        "
        no-body
        class="mb-1"
      >
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            v-b-toggle="'group_base_matter'"
            variant="primary"
            class="d-flex justify-content-center align-items-center"
          >
            {{ $getVisibleNames("teaching.matter", false, "Asignatura Base") }}
            <b-icon
              icon="chevron-down"
              class="ml-2"
              :style="{
                transform:
                  active_collapse_id == 'group_base_matter'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }"
            ></b-icon>
          </b-button>
        </b-card-header>
        <b-collapse
          id="group_base_matter"
          accordion="my-accordion"
          role="tabpanel"
          @show="active_collapse_id = 'group_base_matter'"
          @hidden="
            active_collapse_id == 'group_base_matter'
              ? (active_collapse_id = null)
              : null
          "
        >
          <b-card-body>
            <SpecialPermissionTable
              :access="access"
              :key="'alt-matter' + key_special_permission_table"
              :table_access="table_access"
              :fields="fields_old_matter"
              :egress_profiles_can_update="egressProfilesCanUpdate"
              :faculties_can_update="facultiesCanUpdate"
              :Roles="Roles"
              :busy_table="busy_table"
              :url="'/teaching/alt-matter/'"
              :permission_names="[
                'special.open_base_matter',
                'special.close_base_matter',
                'special.open_base_matter_partial_locks',
                'special.close_base_matter_partial_locks',
              ]"
            >
            </SpecialPermissionTable>
            <!-- <LockAccessCard
              :Table="tablesListDualFiltered"
              :Items="matters"
              :Access="access"
              :allows_crud="allows_crud"
              :open_name="'special.open_base_matter'"
              :close_name="'special.close_base_matter'"
              :egress_profile_matter_card="false"
            /> -->
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card
        v-if="
          access &&
          (isRoleInstitutionalAcademicDirectors ||
            (isRoleFacultyDirectors && hasFacultiesPermission) ||
            (isRoleCareerDirectorsOrInstructionalAdministrators &&
              hasEgressProfilesPermission))
        "
        no-body
        class="mb-1"
      >
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            v-b-toggle="'group_ep_matter'"
            variant="primary"
            class="d-flex justify-content-center align-items-center"
          >
            <!-- v-if="institution && institution.internal_use_id != 'duoc.cl'" -->
            <template>
              {{
                $getVisibleNames(
                  "mesh.egressprofilematter",
                  false,
                  "Asignatura"
                )
              }}
            </template>
            <!-- <template v-else> Apertura y cierre del PMD </template> -->
            <b-icon
              icon="chevron-down"
              class="ml-2"
              :style="{
                transform:
                  active_collapse_id == 'group_ep_matter'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }"
            ></b-icon>
          </b-button>
        </b-card-header>
        <b-collapse
          id="group_ep_matter"
          accordion="my-accordion"
          role="tabpanel"
          @show="active_collapse_id = 'group_ep_matter'"
          @hidden="
            active_collapse_id == 'group_ep_matter'
              ? (active_collapse_id = null)
              : null
          "
        >
          <b-card-body>
            <SpecialPermissionTable
              :access="access"
              :key="'alt-egress-profile-matter' + key_special_permission_table"
              :table_access="table_access"
              :fields="fields_matter"
              :egress_profiles_can_update="egressProfilesCanUpdate"
              :faculties_can_update="facultiesCanUpdate"
              :Roles="Roles"
              :busy_table="busy_table"
              :url="'/mesh/alt-egress-profile-matter/'"
              :permission_names="[
                'special.open_egress_profile_matter',
                'special.close_egress_profile_matter',
              ]"
            >
            </SpecialPermissionTable>
            <!-- <LockAccessCard
              :Table="tablesListDualFiltered"
              :Items="filterEPMatters"
              :Access="access"
              :allows_crud="allows_crud"
              :open_name="'special.open_egress_profile_matter'"
              :close_name="'special.close_egress_profile_matter'"
              :egress_profile_matter_card="true"
            /> -->
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Grupo 3: Partial Locks -->
      <!-- <b-card
        v-if="
          access &&
          (access.role__position__name == 1 || access.role__position__name == 3 || access.role__position__name == 4)
        "
        no-body
        class="mb-1"
      >
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle="'group_partial_locks'" variant="info">
            Candados Parciales de
            {{ $getVisibleNames("teaching.matter", false, "Asignatura Base") }}
          </b-button>
        </b-card-header>
        <b-collapse
          id="group_partial_locks"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <LockAccessCard
              :Table="tablesListDualFiltered"
              :Items="matters"
              :Access="access"
              :allows_crud="allows_crud"
              :open_name="'special.open_base_matter_partial_locks'"
              :close_name="'special.close_base_matter_partial_locks'"
              :egress_profile_matter_card="false"
            />
          </b-card-body>
        </b-collapse>
      </b-card> -->
    </template>
    <template v-else>
      <div class="text-center">
        {{ $t("toolbar.adminUsers.accessRequiresRole") }}
      </div>
    </template>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "AccessForm",
  components: {
    // AccessCard: () => import("./AccessCard/AccessCard.vue"),
    // SpecialAccessCard: () => import("./AccessCard/SpecialAccessCard.vue"),
    // EPMSpecialAccessCard: () => import("./AccessCard/EPMSpecialAccessCard.vue"),
    // LockAccessCard: () => import("./AccessCard/LockAccessCard.vue"),
    SpecialPermissionTable: () =>
      import("@/components/users/AccessCard/SpecialPermissionTable"),
    PermissionTable: () =>
      import("@/components/users/AccessCard/PermissionTable"),
  },

  props: {
    User: {
      type: Object,
      required: true,
    },
    Access: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          user: null,
          role: null,
          school: null,
        };
      },
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    Roles: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      tables_list: [],
      access: { ...this.Access },
      table_access: [],
      // Copia original de table_access para validaciones
      initial_table_access: [],
      busy_table: true,
      key_special_permission_table: 0,
      active_collapse_id: null,
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      careers: names.CAREERS,
      faculties: names.FACULTIES,
      egressProfiles: names.EGRESS_PROFILES,
      egress_profile_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
    }),
    isRoleInstitutionalAcademicDirectors() {
      return this.Roles.some(
        (x) =>
          this.access.role == x.id &&
          x.group__name == "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
      );
    },
    isRoleFacultyDirectors() {
      return this.Roles.some(
        (x) =>
          this.access.role == x.id &&
          x.group__name == "DIRECTIVOS FACULTAD O ESCUELA"
      );
    },
    isRoleCareerDirectors() {
      return this.Roles.some(
        (x) =>
          this.access.role == x.id && x.group__name == "DIRECTORES DE CARRERA"
      );
    },
    isRoleInstructionalAdministrators() {
      return this.Roles.some(
        (x) =>
          this.access.role == x.id &&
          x.group__name == "ADMINISTRATIVOS INSTRUCCIONALES"
      );
    },
    isRoleCareerDirectorsOrInstructionalAdministrators() {
      return (
        this.isRoleCareerDirectors || this.isRoleInstructionalAdministrators
      );
    },
    egressProfilesCanUpdate() {
      if (
        this.access &&
        this.isRoleCareerDirectorsOrInstructionalAdministrators
      ) {
        const access_egp = {
          ...this.initial_table_access.find(
            (x) =>
              // this.$equals(x.name, "mesh.career")
              this.$equals(x.table_name, "mesh.egressprofile") &&
              x.access == this.access.id
          ),
        };
        if (access_egp) return access_egp.can_update;
      }
      return null;
    },
    facultiesCanUpdate() {
      if (this.access && this.isRoleFacultyDirectors) {
        const access_egp = {
          ...this.initial_table_access.find(
            (x) =>
              this.$equals(x.table_name, "mesh.faculty") &&
              x.access == this.access.id
          ),
        };

        if (access_egp) return access_egp.can_update;
      }
      return null;
    },
    // Helper functions para validar permisos
    hasFacultiesPermission() {
      const value = this.facultiesCanUpdate;
      return value === "all" || (value && value !== "" && value !== null);
    },
    hasEgressProfilesPermission() {
      const value = this.egressProfilesCanUpdate;
      return value === "all" || (value && value !== "" && value !== null);
    },
    fields_old_matter() {
      return [
        {
          key: "name",
          label: this.$getVisibleNames(
            "teaching.matter",
            true,
            "Asignaturas Base"
          ).toUpperCase(),
          sortable: false,
          class: "text-left",
          display_column: true,
        },
        {
          key: "special.open_base_matter",
          label: this.$t("reusable.common.openEntity", {
            entity: this.$getVisibleNames(
              "teaching.matter",
              false,
              "Asignatura Base"
            ),
          }).toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "special.close_base_matter",
          label: this.$t("reusable.common.closeEntity", {
            entity: this.$getVisibleNames(
              "teaching.matter",
              false,
              "Asignatura Base"
            ),
          }).toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "special.open_base_matter_partial_locks",
          label: this.$t("reusable.common.openEntity", {
            entity: this.$t("toolbar.adminUsers.partialLocks"),
          }).toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "special.close_base_matter_partial_locks",
          label: this.$t("reusable.common.closeEntity", {
            entity: this.$t("toolbar.adminUsers.partialLocks"),
          }).toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
      ];
    },
    fields_matter() {
      return [
        {
          key: "name",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ).toUpperCase(),
          sortable: false,
          class: "text-left",
          display_column: true,
        },
        {
          key: "egress_profile__professional_title",
          label: this.$getVisibleNames(
            "mesh.egressprofile",
            true,
            "Perfiles de egreso"
          ).toUpperCase(),
          sortable: false,
          class: "text-left",
          display_column: true,
        },
        {
          key: "special.open_egress_profile_matter",
          label: this.$t("reusable.common.openEntity", {
            entity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              true,
              "Asignaturas"
            ),
          }).toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "special.close_egress_profile_matter",
          label: this.$t("reusable.common.closeEntity", {
            entity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              true,
              "Asignaturas"
            ),
          }).toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
      ];
    },
    fields_egress_profiles() {
      return [
        {
          key: "name",
          label: this.$getVisibleNames(
            "mesh.egressprofile",
            true,
            "Perfiles de egreso"
          ).toUpperCase(),
          sortable: false,
          class: "text-left",
          display_column: true,
        },
        {
          key: "can_read",
          label: this.$t("reusable.common.view").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "can_update",
          label: this.$t("reusable.common.edit").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "can_delete",
          label: this.$t("reusable.common.delete").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
      ];
    },
    fields_close_egress_profiles() {
      return [
        {
          key: "name",
          label: this.$getVisibleNames(
            "mesh.egressprofile",
            true,
            "Perfiles de egreso"
          ),
          sortable: false,
          class: "text-left",
          display_column: true,
        },
        {
          key: "special.close_egress_profile",
          label: this.$t("reusable.common.closeEntity", {
            entity: this.$getVisibleNames(
              "mesh.egressprofile",
              true,
              "Perfiles de egreso"
            ),
          }),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
      ];
    },
    fields_career() {
      return [
        {
          key: "name",
          label: this.$getVisibleNames(
            "mesh.career",
            true,
            "Carreras"
          ).toUpperCase(),
          sortable: false,
          class: "text-left",
          display_column: true,
        },
        {
          key: "can_read",
          label: this.$t("reusable.common.view").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "can_update",
          label: this.$t("reusable.common.edit").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        // this.access &&
        // this.access.role__position__name ==
        //   "ADMINISTRATIVOS INSTRUCCIONALES"
        //   ? false
        //   :
        {
          key: "can_delete",
          label: this.$t("reusable.common.delete").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
      ];
    },
    fields_faculties() {
      return [
        {
          key: "name",
          label: this.$getVisibleNames("mesh.faculty", true, "Facultades"),
          sortable: false,
          class: "text-left",
          display_column: true,
        },
        {
          key: "can_read",
          label: this.$t("reusable.common.view").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "can_update",
          label: this.$t("reusable.common.edit").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
        {
          key: "can_delete",
          label: this.$t("reusable.common.delete").toUpperCase(),
          display_column: true,
          thClass: "text-center",
          tdClass: "text-center align-content-center",
        },
      ];
    },
    tablesListFiltered() {
      let tables_list_filtered = [];
      if (this.access && this.isRoleInstitutionalAcademicDirectors)
        return this.tables_list
          .filter((x) =>
            // this.$equals(x.name, "special.close_egress_profile_matter") ||
            // this.$equals(x.name, "special.open_base_matter") ||
            // this.$equals(x.name, "special.close_base_matter") ||
            // this.$equals(x.name, "special.open_base_matter_partial_locks") ||
            // this.$equals(x.name, "special.close_base_matter_partial_locks") ||
            this.$equals(x.name, "special.close_egress_profile")
          )
          .sort((a, b) => a.name.localeCompare(b.name));
      if (this.access && this.isRoleFacultyDirectors)
        return this.tables_list.filter(
          (x) => this.$equals(x.name, "mesh.faculty")
          // this.$equals(x.name, "special.open_base_matter_partial_locks") ||
          // this.$equals(x.name, "special.close_base_matter_partial_locks") ||
          // this.$equals(x.name, "special.open_base_matter") ||
          // this.$equals(x.name, "special.close_base_matter")
        );
      if (
        this.access &&
        this.isRoleCareerDirectorsOrInstructionalAdministrators
      )
        return this.tables_list.filter(
          (x) => this.$equals(x.name, "mesh.egressprofile")
          // ||
          // this.$equals(x.name, "mesh.career")
          // this.$equals(x.name, "special.open_base_matter_partial_locks") ||
          // this.$equals(x.name, "special.close_base_matter_partial_locks") ||
          // this.$equals(x.name, "special.open_base_matter") ||
          // this.$equals(x.name, "special.close_base_matter")
        );
      return tables_list_filtered;
    },
    tablesListDualFiltered() {
      let tables_list_filtered = [];
      if (
        this.access &&
        (this.isRoleInstitutionalAcademicDirectors ||
          this.isRoleFacultyDirectors ||
          this.isRoleCareerDirectorsOrInstructionalAdministrators)
      )
        return this.tables_list
          .filter(
            (x) =>
              this.$equals(x.name, "special.open_base_matter") ||
              this.$equals(x.name, "special.close_base_matter") ||
              this.$equals(x.name, "special.open_egress_profile_matter") ||
              this.$equals(x.name, "special.close_egress_profile_matter") ||
              this.$equals(x.name, "special.open_base_matter_partial_locks") ||
              this.$equals(x.name, "special.close_base_matter_partial_locks")
          )
          .sort((a, b) => a.name.localeCompare(b.name));
      return tables_list_filtered;
    },
    // filterEPMatters() {
    //   let list = [];
    //   this.egressProfiles.forEach((egress_profile) => {
    //     const egress_profile_matters = this.egress_profile_matters.filter(
    //       (x) => x.egress_profile == egress_profile.id
    //     );
    //     if (egress_profile_matters.length > 0)
    //       list.push({
    //         id: egress_profile.id,
    //         name: String(egress_profile.name),
    //         options: egress_profile_matters.sort(function (a, b) {
    //           if (a.order > b.order) return 1;
    //           if (a.order < b.order) return -1;
    //         }),
    //       });
    //   });
    //   return list;
    // },
  },
  methods: {
    temporalTableAccess(table) {
      this.table_access.push({
        id: generateUniqueId(),
        table: table.id,
        access: this.access.id,
        table_name: table.name,
        can_create: false,
        can_read: "",
        can_update: "",
        can_delete: "",
        can_do_special_behavior: "",
      });
    },
    async fetchTableAccess() {
      this.table_access = [];
      if (
        (this.access && this.tablesListDualFiltered) ||
        this.tablesListFiltered
      )
        for await (let table of this.tablesListDualFiltered) {
          await this.$restful
            .GetAll(
              `/teaching/table-access/?table=${table.id}&access=${this.access.id}`
            )
            .then((response) => {
              if (response.length > 0) this.table_access.push(response[0]);
              else {
                this.temporalTableAccess(table);
              }
            });
        }
      for await (let table of this.tablesListFiltered) {
        await this.$restful
          .GetAll(
            `/teaching/table-access/?table=${table.id}&access=${this.access.id}`
          )
          .then((response) => {
            if (response.length > 0) this.table_access.push(response[0]);
            else {
              this.temporalTableAccess(table);
            }
          });
      }
      // Guardar copia original para validaciones
      this.initial_table_access = JSON.parse(JSON.stringify(this.table_access));
      this.busy_table = false;
    },
    changedPermissions() {
      this.initial_table_access = JSON.parse(JSON.stringify(this.table_access));
      this.key_special_permission_table++;
      // Solo cerrar el primer collapse y abrir los siguientes si hay permisos
      // de edición (can_update) seleccionados, o si es director institucional
      const hasEditPermission =
        this.hasFacultiesPermission || this.hasEgressProfilesPermission;
      const shouldTransition =
        this.isRoleInstitutionalAcademicDirectors || hasEditPermission;
      if (shouldTransition) {
        if (this.active_collapse_id) {
          this.$root.$emit("bv::toggle::collapse", this.active_collapse_id);
        }
        this.$nextTick(() => {
          this.$root.$emit("bv::toggle::collapse", "group_base_matter");
        });
      }
    },
  },
  mounted() {},
  created() {
    this.$restful.GetAll(`/teaching/table/`).then((response) => {
      this.tables_list = response;
      this.$restful
        .GetAll(`/teaching/access/?user=${this.User.id}`)
        .then((response) => {
          if (response.length > 0) this.access = response[0];
          if (
            this.tablesListDualFiltered.length > 0 &&
            !isNaN(this.access.id)
          ) {
            this.fetchTableAccess();
          } else {
            this.busy_table = false;
          }
        });
    });
  },
};
</script>

<style scoped>
</style>